import React, { useEffect, useState } from 'react';
import ProzoDataGrid from '../../common/ProzoDataGrid';
import { Box, Typography, Chip, Button } from '@mui/material';
import { maskAddress, parseDateAndTime, shouldMaskData } from '../../helpers/UtilityHelper';
import Loader from '../../common/Loader';
import { useGetNDRDataQuery } from '../../redux/commonRTK';
import { buildFilterConditions } from '../../helpers/UtilityHelper';
import { ActionLogModal } from '.';
import { LoadingButton } from "@mui/lab";
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { useSnackbar } from "notistack";
import { downloadNdrList } from "./downloadNdr";
import { useSelector } from 'react-redux';
import { getMerchant, getToken } from '../../helpers/ReduxHelpers';
import jwt_decode from "jwt-decode"
import { primaryTextSx, secondaryTextSx, cellStackSx, awbTextSx, getStatusChipSx, getPaymentChipSx } from '../orders/list2/cellStyles';
import { FONT, SIZE } from '../../styles/foundation/typography';
import { secondaryBtnSx } from '../../styles/patterns';
import { SUBTLE } from '../../styles/foundation/colors';
import AwbLinkCell from '../../common/AwbLinkCell';
const NETRA_BAND_COLOR = { EXCELLENT: '#2e7d32', GOOD: '#0288d1', FAIR: '#ed6c02', POOR: '#d32f2f' };


const ClosedNdrData = (props) => {

    const [page, setPage] = useState(0);
    const [sizePerPage, setSizePerPage] = useState(10);
    const [closeddNdrData, setClosedNDRData] = useState({});
    const [logModal, setLogModal] = useState(false);
    const [logModalData, setLogModalData] = useState();
    const merchant = getMerchant();
    const merchantId = merchant.id ? merchant.id : ''
    const { report } = useSelector(state => state);
    const { piiAccessAllow } = jwt_decode(getToken());

    const exclude =
        "terminalStatus,shipmentDetail.cartonItems,invoiceNumber,shipmentType,returnInfo,labelUrl,dispatchMode,giftwrapCharge,transactionCharge,shippingCharge,pickupDetails,isInsured,codType,riskType,appointmentDelivery,async,order_date,courierDetail.prozoId,courierDetail.key,createdDate,actualPickUpTime,lastStatusUpdateTime,epd,edd,order_history,merchantPricing,merchant,courier,orderManifest,invoiceUrl,courierPricingRTO,courierPricing,overriddenCourierAccountCode,actualCourierProviderName,isDiscrepancyRaised,discrepancyId,securityKey,sortCode,channelType,channelName,itemList,createdByUser,skipRule,modifiedByUser,rvp_reason,channel_name,customerDetail,cpErrorList,mongoLabelSignedUrlDetails,overriddenCourierRule,mongoInvoiceSignedUrlDetails,merchant,modifiedByUser,lastModifiedDate,manifestDetails,communicationStatus,eddRemark,timeoutRetryCounter,isAutoApprovedReturn,appointdeliveryRequired,autoApprovedReturn,isManualCreate,gst_info,failureCategory";
    const filterConditions = buildFilterConditions(props.filters);
    const { enqueueSnackbar } = useSnackbar();
    const andfilter = [
        { field: "ndrData.ndrStatus", operator: "eq", value: "CLOSED" },
        { field: "merchant.$id", operator: "eq", value: merchantId },
        ...filterConditions.andfilter
    ];
    const orfilter = [...filterConditions.orfilter];

    const [downloading, setDownloading] = useState(false);
    const handleDownload = async () => {
        setDownloading(true);
        try {
            const n = await downloadNdrList({ andfilter, orfilter, excludes: exclude, fileName: `NDR_Closed_${new Date().toISOString().slice(0, 10)}.xlsx` });
            if (!n) enqueueSnackbar("No records to download", { variant: "info" });
        } catch (e) {
            enqueueSnackbar("Download failed, please try again", { variant: "error" });
        } finally {
            setDownloading(false);
        }
    };

    const { data: closeddData, isLoading } = useGetNDRDataQuery({
        andfilter,
        orfilter,
        offset: page * sizePerPage,
        limit: sizePerPage,
        skipCount: true,
        excludes: exclude,
        sort: { "field": "awbRegisteredDate", "direction": "DESC" },
    });

    useEffect(() => {
        setPage(0)
    }, [sizePerPage, props.filters])

    const columns = [
        {
            field: 'orderdetails', headerAlign: "left", hideSortIcons: true, headerName: 'Order Details', flex: 1.2, minWidth: 180, renderCell: (params) => {
                const { row } = params;
                const paymentMode = row.payment_mode || '';
                return (
                    <Box sx={cellStackSx}>
                        <Typography sx={primaryTextSx}>{row.reference}</Typography>
                        {row.shippingLabelId && row.reference !== row.shippingLabelId && (
                            <Typography sx={secondaryTextSx}>{row.shippingLabelId}</Typography>
                        )}
                        <Typography sx={secondaryTextSx}>
                            {(row.awbRegisteredDate) ? parseDateAndTime(row.awbRegisteredDate) : ""}
                        </Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            {row.invoice_value && <Typography sx={primaryTextSx}>Rs. {row.invoice_value}</Typography>}
                            {paymentMode && <Chip size="small" label={paymentMode} sx={getPaymentChipSx(paymentMode)} />}
                        </Box>
                    </Box>
                )
            },
        },
        {
            field: 'courierDetails', headerAlign: "left", hideSortIcons: true, headerName: 'Courier Details', flex: 1, minWidth: 160, renderCell: (params) => {
                const { row } = params;
                return (
                    <Box sx={cellStackSx}>
                        <AwbLinkCell awb={row.awb_number} sx={awbTextSx} />
                        <Typography sx={secondaryTextSx}>{row?.courierDetail?.parent || row?.courierDetail?.name}</Typography>
                    </Box>
                )
            },
        },
        {
            field: 'addressQuality', headerAlign: "left", hideSortIcons: true, headerName: 'Address Quality', flex: 0.6, minWidth: 100, renderCell: (params) => {
                const { row } = params;
                if (!row.netra_address || row.netra_address.score == null) return <Typography sx={secondaryTextSx}>-</Typography>;
                const score = Math.round(Number(row.netra_address.score));
                const band = row.netra_address.band || '';
                const bgColor = NETRA_BAND_COLOR[band] || '#616161';
                return (
                    <Chip size="small" label={`${band} · ${score}`} sx={{ backgroundColor: bgColor, color: '#fff', fontWeight: 600, fontSize: 11 }} />
                )
            },
        },
        {
            field: 'status', headerAlign: "left", hideSortIcons: true, headerName: 'Current Status', flex: 1, minWidth: 130, renderCell: (params) => {
                const { row } = params;
                const orderStatus = row.orderStatus.replace(/_/g, ' ');
                const ofdCount = row.ndrData?.ofdCount || 0;
                return (
                    <Box sx={cellStackSx}>
                        <Chip size="small" label={orderStatus} sx={getStatusChipSx(row.orderStatus)} />
                        <Chip size="small" label={`OFD Attempts : ${ofdCount}`} sx={{ fontFamily: FONT, fontSize: 11, fontWeight: 600, height: 22, bgcolor: '#e3f2fd', color: '#1565c0', border: '1px solid #90caf940', '& .MuiChip-label': { px: 1 } }} />
                    </Box>
                )
            },
        },
        {
            field: 'shipment', headerAlign: "left", hideSortIcons: true, headerName: 'Delivery Address', flex: 1.5, minWidth: 200, renderCell: (params) => {
                const { row } = params;
                return (
                    <Box sx={cellStackSx}>
                        <Typography sx={secondaryTextSx}>
                            Name : {row.delivery_details.to_name}
                        </Typography>
                        <Typography sx={secondaryTextSx}>
                            {shouldMaskData(report, row, piiAccessAllow) ? maskAddress(
                                row.delivery_details.to_address,
                                row.delivery_details.to_city,
                                row.delivery_details.to_state,
                                row.delivery_details.to_pincode
                            ) : (
                                <>
                                    {row.delivery_details.to_address}
                                    {row.delivery_details.to_city}
                                    {row.delivery_details.to_state}
                                    {row.delivery_details.to_pincode}
                                </>
                            )}
                        </Typography>
                    </Box>
                )
            },
        },
        {
            field: 'ndrReason', headerAlign: "left", hideSortIcons: true, headerName: 'NDR Reason', flex: 1.5, minWidth: 200, renderCell: (params) => {
                const { row } = params;
                return (
                    <Box sx={cellStackSx}>
                        <Typography sx={primaryTextSx}>
                            {(row.ndrData && row.ndrData.ndrCpStatusDescription) ? row.ndrData.ndrCpStatusDescription : "-NA-"}
                        </Typography>
                        <Typography sx={secondaryTextSx}>
                            {(row.ndrData && row.ndrData.ndrReportedDate) ? parseDateAndTime(row.ndrData.ndrReportedDate, true) : ""}
                        </Typography>
                        {row.ndrData?.remark && (
                            <Typography sx={{ fontFamily: FONT, fontSize: 11, fontStyle: 'italic', color: SUBTLE, lineHeight: 1.4 }}>
                                {row.ndrData.remark}
                            </Typography>
                        )}
                    </Box>
                )
            },
        },
        {
            field: 'actionLog', headerAlign: "left", hideSortIcons: true, headerName: 'Action Log', flex: 0.8, minWidth: 100, renderCell: (params) => {
                const { row } = params;
                return (
                    <Button
                        sx={{ fontFamily: FONT, fontSize: SIZE['2xs'], textTransform: 'none', p: 0, minWidth: 0 }}
                        onClick={() => {
                            setLogModalData(row?.ndrData?.actionUpdateLog);
                            setLogModal(true);
                        }}
                    >
                        View
                    </Button>
                )
            },
        },
    ];

    useEffect(() => {
        if (closeddData) {
            setClosedNDRData(closeddData);
        }
    }, [closeddData]);


    return (
        <Box>
            {(isLoading) && <Loader />}
            <ActionLogModal data={logModalData} logModal={logModal} setLogModal={setLogModal} />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 1.5 }}>
                <LoadingButton loading={downloading} onClick={handleDownload} variant="outlined" size="small" startIcon={<FileDownloadOutlinedIcon />} sx={secondaryBtnSx}>
                    Download
                </LoadingButton>
            </Box>
            <ProzoDataGrid columns={columns}
                autoHeight={true}
                rows={(closeddNdrData.data && closeddNdrData.data.length > 0) ? closeddNdrData.data : []}
                sizePerPage={sizePerPage}
                setSizePerPage={setSizePerPage}
                setPage={setPage}
                page={page}
                pagination={true}
                hideFooterPagination={false}
                filterMode={"server"}
                rowCount={Number.MAX_VALUE}
                getRowId={(row) => row.id} />
        </Box>
    );
};

export default ClosedNdrData
